import { stripePriceToPlanMap as jackTesting } from './local/jackTesting';
import { stripePriceToPlanMap as ashTesting } from './local/ashTesting';
import { stripePriceToPlanMap as stagingJuly2023 } from './staging/july2023';
import { stripePriceToPlanMap as productionJuly2023 } from './production/july2023';
import { stripePriceToPlanMap as legacy } from './production/legacy';
import { stripePriceToPlanMap as development } from './development/july2023';
export const stripePriceToPlanMap = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, legacy), jackTesting), ashTesting), stagingJuly2023), productionJuly2023), development);
//# sourceMappingURL=index.js.map